export default {
	bloglist: {
		en: [
			{
				title: 'Can Someone With WhatsApp GB See Hidden Status?',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Learn how WhatsApp Status privacy works, what GB WhatsApp users can see, and why hidden Status updates are not normally visible to excluded contacts.',
				name: 'en-can-whatsapp-gb-see-hidden-status',
				url: '/can-whatsapp-gb-see-hidden-status/',
				date: '2026-08-10',
			},
			{
				title: 'How to Hack GB WhatsApp? What You Should Know',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Learn the myths, security risks, and practical ways to protect your GB WhatsApp account from scams, phishing, and unsafe APK downloads.',
				name: 'en-how-to-hack-gb-whatsapp',
				url: '/how-to-hack-gb-whatsapp/',
				date: '2026-07-17',
			},
			{
				title: 'How to Add Stickers in GB WhatsApp',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Add sticker packs, create custom stickers, manage favorites, and fix common sticker issues in GB WhatsApp.',
				name: 'en-how-to-add-stickers-in-gb-whatsapp',
				url: '/how-to-add-stickers-in-gb-whatsapp/',
				date: '2026-07-17',
			},
			{
				title: 'How to Change GB WhatsApp Home Screen Wallpaper',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Change GB WhatsApp wallpapers, apply themes, restore defaults, and fix wallpaper display problems with simple steps.',
				name: 'en-change-gb-whatsapp-home-screen-wallpaper',
				url: '/change-gb-whatsapp-home-screen-wallpaper/',
				date: '2026-07-17',
			},
			{
				title: 'GB WhatsApp Setup Guide After Installation',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'First-time GB WhatsApp settings after install—privacy, chats, media, notifications—with clear steps beginners can follow.',
				name: 'en-gb-whatsapp-setup-after-install',
				url: '/gb-whatsapp-setup-guide-after-installation/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Advanced Settings Guide',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Learn advanced settings and hidden configurations for professional GB WhatsApp users—notifications, privacy, chat behavior, and media control in plain steps.',
				name: 'en-gb-whatsapp-advanced-settings',
				url: '/gb-whatsapp-advanced-settings-guide/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Storage Full Fix Guide',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Fix storage full problems and learn how to clear cache and free space safely—manage media files, chat data, and auto-download settings.',
				name: 'en-gb-whatsapp-storage-full',
				url: '/gb-whatsapp-storage-full-fix/',
				date: '2026-05-09',
			},
			{
				title: 'Fix GB WhatsApp Lag & Performance Issues',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Improve GB WhatsApp speed, fix lag, crashes, and performance issues—cache cleanup, storage, and prevention tips for Android.',
				name: 'en-gb-whatsapp-lag-fix',
				url: '/gb-whatsapp-lag-performance-fix/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Group Management & Admin Tools',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Learn how to manage groups, use admin tools, and control group settings—in plain language with tables and numbered steps.',
				name: 'en-gb-whatsapp-group-management',
				url: '/gb-whatsapp-group-management-guide/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Account Recovery Guide',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'A practical walkthrough when access breaks—verification, backups, cautious reinstall, and realistic expectations.',
				name: 'en-gb-whatsapp-account-recovery',
				url: '/gb-whatsapp-account-recovery-guide/',
				date: '2026-05-09',
			},
			{
				title: 'Fix GB WhatsApp Media Not Loading',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Solve media not downloading or images not showing—connection, storage, cache, and reinstall fixes step by step.',
				name: 'en-gb-whatsapp-media-not-loading',
				url: '/gb-whatsapp-media-not-loading-fix/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Chat Privacy & Hidden Controls',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Control privacy settings, hide online status, and manage chat visibility—simple steps matching your GB WhatsApp menus.',
				name: 'en-gb-whatsapp-chat-privacy',
				url: '/gb-whatsapp-chat-privacy-hidden-controls/',
				date: '2026-05-09',
			},
			{
				title: 'Switch From Official WhatsApp to GB WhatsApp Safely',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Learn how to switch without losing chats—backup, install GB WhatsApp, restore, plus common migration issues.',
				name: 'en-switch-to-gb-whatsapp',
				url: '/switch-from-official-whatsapp-to-gb-whatsapp/',
				date: '2026-05-09',
			},
			{
				title: 'GB WhatsApp Verification Code Not Working Fix',
				poster: require('@/assets/blog-cover-new.png'),
				desc:
					'Fix verification code not received or not working with simple checks—network, phone number, and alternative methods.',
				name: 'en-gb-whatsapp-verification-fix',
				url: '/gb-whatsapp-verification-code-not-working-fix/',
				date: '2026-05-09',
			},
			{
				title: 'How to Schedule Messages in GBWhatsApp?',
				poster: require('@/assets/blog-1.webp'),
				desc: 'This guide explains how to schedule messages in GBWhatsApp with this detailed step-by-step guide. Automate chats, send messages on time, and improve communication efficiency easily.',
				name: 'en-schedule-messages-in-gbwhatsapp',
				url: '/schedule-messages-in-gbwhatsapp/',
				date: '2025-12-05',
			},
			{
				title: 'How to Create a GBWhatsApp Theme?',
				poster: require('@/assets/blog-2.webp'),
				desc: "Learn how to create custom themes in GB WhatsApp by editing backgrounds, fonts, colors, and icons to enhance your app's visual appeal and user experience.",
				name: 'en-create-a-gbwhatsapp-theme',
				url: '/create-a-gbwhatsapp-theme/',
				date: '2026-01-08',
			},
		].sort((a, b) => new Date(b.date) - new Date(a.date)),
	},
};
